<template>
  <div
    class="infotype-checkbox"
  >
    <MyCheckbox
      :data="data"
      class="info-type"
      :class="{ 'border': infoSign }"
      @change="handleChange($event, 'info_type')"
    />
    <MyCheckbox
      v-if="infoSign"
      :data="infoSign"
      class="info-sign"
      @change="handleChange($event, 'info_sign')"
    />
  </div>
</template>

<script>
import MyCheckbox from './../formItem/CheckBox'
export default {
  components: {
    MyCheckbox
  },
  props: {
    'data': {
      type: [Object, Array, String, Boolean],
      default: () => ({})
    }
  },
  data () {
    return {
      beianValue: []
    }
  },
  computed: {
    infoSign () {
      const { fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign } = fieldconfig
      if (infoSign && infoSign.fieldkey) {
        infoSign.fieldname = ''
      }

      return infoSign
    }
  },
  methods: {
    handleChange (val, type) {
      if (type === 'info_type') {
        this.data.fieldvalue = val
      } else if (type === 'info_sign' && this.data.fieldconfig && this.data.fieldconfig.info_sign) {
        this.data.fieldconfig.info_sign.fieldvalue = val
        this.beianValue = val
      }

      this.$emit('change', this.data.fieldvalue || [], this.data)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.info-type  {
  margin-bottom: 10px;
   &.border ::v-deep {
    .ant-checkbox-group {
      border-bottom: solid 1px #dbdbdb;
    }
  }
}
</style>
